import Navbar from '../components/Navbar/Navbar'
import Climates from '../components/Climates/Climates'
import ClimateProducts from '../components/ClimateProducts/ClimateProducts'
import Footer from '../components/Footer/Footer'


const Climate = () => {
    return(
        <>
            <Navbar />
            <main className='climate'>
                <h1>Climatización</h1>
            </main>
            <Climates />
            <ClimateProducts />
            <Footer />
        </>
    )
}

export default Climate